import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { ListChannelBans } from "../schemas/schemas_0";
export { $Command };
export class ListChannelBansCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [getEndpointPlugin(config, Command.getEndpointParameterInstructions())];
})
    .s("ChimeMessagingService", "ListChannelBans", {})
    .n("ChimeSDKMessagingClient", "ListChannelBansCommand")
    .sc(ListChannelBans)
    .build() {
}
